import jQuery from 'jquery';

jQuery($ => {
    let $table = $('table'),
        direction = {
            left: 1,
            right: -1
        };

    if ($table.length) {
        require.ensure([], () => {
            $table.each(function () {
                let $table = $(this),
                    $tableScroll = $table.closest('.table-scroll'),
                    scrollOffset = 20,
                    tableScrolling, distancePerTick = 10,
                    table = this, tableScroll, canShowIndicators,
                    $indicators, $indicatorLeft, $indicatorRight;

                if (!$tableScroll.length) {
                    $tableScroll = $('<div class="table-scroll" />').insertBefore($table).append($table);
                }

                tableScroll = $tableScroll[0];

                $tableScroll.wrap($('<div class="table-scroll-indicators" />'));

                $indicatorLeft = $(`<div class="table-scroll-indicators__indicator table-scroll-indicators__indicator--left">
                    <button class="btn btn--icon"><i class="icon icon--arrow-2ndLevel-left"></i></button>
                </div>`).prependTo($tableScroll);

                $indicatorRight = $(`<div class="table-scroll-indicators__indicator table-scroll-indicators__indicator--right">
                    <button class="btn btn--icon"><i class="icon icon--arrow-2ndLevel-right"></i></button>
                </div>`).appendTo($tableScroll);

                $indicators = $()
                    .add($indicatorLeft)
                    .add($indicatorRight);

                function showIndicators() {
                    $indicatorLeft.toggleClass('is-visible', canShowIndicators && tableScroll.scrollLeft !== 0);
                    $indicatorRight.toggleClass('is-visible', canShowIndicators && tableScroll.scrollLeft < table.scrollWidth - $tableScroll.width());
                }

                function hideIndicators() {
                    $indicators.removeClass('is-visible');
                }

                $(window).on('resize', () => {
                    $indicators.height($table.outerHeight());

                    canShowIndicators = table.scrollWidth > $tableScroll.width() + scrollOffset;

                    if (canShowIndicators) {
                        showIndicators();
                    } else {
                        hideIndicators();
                    }
                }).trigger('resize');

                $tableScroll.on('scroll', () => {
                    showIndicators();
                });

                function scrollStop() {
                    clearInterval(tableScrolling);
                }

                function scrollStart(direction) {
                    scrollStop();

                    tableScrolling = setInterval(function () {
                        tableScroll.scrollLeft -= distancePerTick * direction;
                    }, 10);
                }

                function startLeftScrolling(event) { event.preventDefault(); scrollStart(direction.left); }
                function startRightScrolling(event) { event.preventDefault(); scrollStart(direction.right); }
                function stopScrolling(event) { event.preventDefault(); scrollStop(); }


                $('.table-scroll-indicators__indicator--left .btn')
                    .on('mousedown', startLeftScrolling)
                    .on('touchstart', startLeftScrolling)
                    .on('mouseup', stopScrolling)
                    .on('mouseleave', stopScrolling)
                    .on('touchend', stopScrolling)
                    .on('touchleave', stopScrolling)
                    .on('touchcancel', stopScrolling);

                $('.table-scroll-indicators__indicator--right .btn')
                    .on('mousedown', startRightScrolling)
                    .on('touchstart', startRightScrolling)
                    .on('mouseup', stopScrolling)
                    .on('mouseleave', stopScrolling)
                    .on('touchend', stopScrolling)
                    .on('touchleave', stopScrolling)
                    .on('touchcancel', stopScrolling);
            });
        }, 'table');
    }
});



// WEBPACK FOOTER //
// ./resources/assets/js/lib/table.js